import { Component } from 'react'

import logger from '~/lib/logger'
import BrokenPage from '~/apps/consumer/pages/shared/BrokenPage'

export default class SentryErrorBoundary extends Component {
    state = { error: null }

    componentDidCatch(error, errorInfo) {
        this.setState({ error })
        logger.exception(error, { extra: errorInfo })
    }

    render() {
        if (this.state.error) {
            return <BrokenPage status={500} />
        }
        //when there's not an error, render children untouched
        return this.props.children
    }
}
